import '~/js/modules/magnific-popup';
import 'slick-carousel';

$(document).on('click', '.js-magnific-popup', function showSlider() {
    const arrowsParent = $(this).attr('href');
    const $slider = $(`${arrowsParent} .js-slick-slider-inclusions`);
    const $slickSetup = {
        accessibility: false,
        arrows: true,
        infinite: false,
        centerPadding: '0',
        cssEase: 'ease-out',
        pauseOnFocus: false,
        pauseOnHover: false,
        appendArrows: $(`${arrowsParent} .js-slide-navigation`),
        speed: 500
    };

    function setCorrectArrowsPosition() {
        const HeightCurrentSlideImg = $slider.find('.slick-active img').height();
        const HeightCurrentSlideDescription = $slider.find('.slick-active .slider-content').outerHeight();

        $(`${arrowsParent} .js-slide-navigation`).css('top', HeightCurrentSlideImg);
        $(`${arrowsParent} .js-slide-navigation`).css('height', HeightCurrentSlideDescription);
    }

    $slider.on('init', () => {
        setCorrectArrowsPosition();
    });

    if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
        $slider.slick($slickSetup).resize();
    } else {
        $slider.slick($slickSetup).resize();
    }

    $slider.on('afterChange', () => {
        setCorrectArrowsPosition();
    });

    $(window).resize(() => {
        setTimeout(setCorrectArrowsPosition, 1000);
    });
});
